var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoGalleryVrs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-bce6807a-ac68-408d-8763-14938ea6efc1",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c1cfd7a2-6229-4ed3-9f1b-80f557fb2a37",
    x1: 25.87,
    y1: -132.96,
    x2: 83.87,
    y2: -190.96,
    gradientTransform: "translate(0 -135) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    className: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    className: "stop1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ac9125af-58ca-4614-85f6-6db7e0c5987d",
    x1: 21.21,
    y1: -142.3,
    x2: 90.87,
    y2: -211.96,
    xlinkHref: "#uuid-c1cfd7a2-6229-4ed3-9f1b-80f557fb2a37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-3bae7f36-c123-4568-a759-9907e2a6583e",
    x1: 28.09,
    y1: 42.09,
    x2: 62.91,
    y2: 76.91,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#uuid-c1cfd7a2-6229-4ed3-9f1b-80f557fb2a37"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m75.5,63.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-c1cfd7a2-6229-4ed3-9f1b-80f557fb2a37)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68.5,70.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-ac9125af-58ca-4614-85f6-6db7e0c5987d)",
    opacity: 0.5,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m61.5,41.5H29.5c-1.1,0-2,.9-2,2v32c0,1.1.9,2,2,2h32c1.1,0,2-.9,2-2v-32c0-1.1-.9-2-2-2Zm-8.31,20.45c-.5.23-1.1,0-1.33-.49s0-1.1.49-1.33c1.52-.7,2.43-1.6,2.43-2.42,0-1.75-3.97-3.71-9.29-3.71s-9.29,1.96-9.29,3.71c0,1.62,3.39,3.41,8.09,3.68l-1.84-1.84c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l3.59,3.59c.39.39.39,1.02,0,1.41l-3.59,3.59c-.2.2-.45.29-.71.29s-.51-.1-.71-.29c-.39-.39-.39-1.02,0-1.41l1.91-1.91c-5.86-.27-10.15-2.62-10.15-5.69,0-3.26,4.85-5.71,11.29-5.71s11.29,2.46,11.29,5.71c0,1.67-1.28,3.18-3.6,4.24Z",
    fill: "url(#uuid-3bae7f36-c123-4568-a759-9907e2a6583e)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoGalleryVrs);
export default __webpack_public_path__ + "static/media/expo_gallery_vrs.284dbf5691a7b8303370afdd40f8ccdd.svg";
export { ForwardRef as ReactComponent };